/** Sort user lists A→Z by display name for dropdowns and pickers. */
export const sortUsersByName = (users) =>
  [...(users || [])].sort((a, b) =>
    (a?.name || '').localeCompare(b?.name || '', undefined, { sensitivity: 'base' })
  );
